import { eInternalOrderStatus } from 'ui-toolkit/enums/eInternalOrderStatus';
import { ICreateInternalContactRequest } from '../contacts/CreateInternalContact';
import { IContactUSAStates } from '../contacts/IContactUSAStates';
import { UUID } from '../shared/UUID';

export interface ICreateDefaultContactRequest extends Omit<ICreateInternalContactRequest, 'roles' | 'phoneExtension' | 'timeZone'> {
  roles: IDefaultContactRoles;
  clientCompanyId: string;
}

export type IDefaultContactRoles = Partial<Record<string, Array<IContactUSAStates>>>;
export type TDefaultContactUpdateType = 'CREATE' | 'UPDATE' | 'DELETE';
export type ICreateDefaultContactData = ICreateDefaultContactRequest;
export type IAddEditDefaultContactData = ICreateDefaultContactData & {
  id?: string; // Required for update and delete operations
  updateOrders: boolean;
  updateType: TDefaultContactUpdateType;
  statusLowerRange?: eInternalOrderStatus;
  statusUpperRange?: eInternalOrderStatus;
};

export interface IAffectedOrders {
  affectedOrders: number;
}

// New types for the calculate-impact endpoint
export type OperationType = 'CREATE' | 'UPDATE' | 'DELETE';

export interface ICalculateImpactRequest {
  adminId: UUID;
  statusLowerRange?: eInternalOrderStatus;
  statusUpperRange?: eInternalOrderStatus;
  roles: IDefaultContactRoles;
  operation: OperationType;
}

export interface ICalculateImpactResponse {
  affectedOrdersCount: number;
}

export const convertFromICreateDefaultContactDataToICreateDefaultContactRequest = (
  data: ICreateDefaultContactData,
  clientId: string,
): ICreateDefaultContactRequest => ({
  ...data,
  clientCompanyId: clientId,
});

export const forbiddenInternalOrderStatuses: eInternalOrderStatus[] = [
  eInternalOrderStatus.new,
  eInternalOrderStatus.cancelled,
  eInternalOrderStatus.closing,
  eInternalOrderStatus.post_closing,
  eInternalOrderStatus.complete,
  eInternalOrderStatus.policy_issued,
];
